import type { MapCanvasValue } from "../components/map/contexts/MapCanvasContext/MapCanvasContext.types";

/** Apply editor defaults only after map calibration. Avoid inflating thin source
 * walls by more than 50%; small plans retain their traced width, rounded to units. */
export function normalizeImportedWallWidths(
  map: MapCanvasValue
): MapCanvasValue {
  return {
    ...map,
    shapes: map.shapes.map((shape) => {
      if (shape.type !== "wall" && shape.type !== "wall-path") return shape;
      if (!Number.isFinite(shape.thickness) || shape.thickness <= 0)
        return shape;
      const preferred = shape.layerLabel === "Exterior walls" ? 32 : 16;
      return {
        ...shape,
        thickness:
          preferred <= shape.thickness * 1.5
            ? preferred
            : Math.max(1, Math.round(shape.thickness))
      };
    })
  };
}
